<template>
  <div class="content">
    <div class="row">
      <div class="col-12">
        <card type="chart">
          <template slot="header">
            <div class="row">
              <div class="col-sm-6">
                <template>
                  <h4 class="card-title text-left">Mural de Informações</h4>
                </template>
              </div>
            </div>
          </template>
          <div class="row">
            <h4 class="text-h4">Canal de Novidades</h4>
            <p class="text-p">
              Pedimos que sempre realize leitura deste canal, aqui
              disponibilizaremos e informaremos as últimas atualizações do
              sistema.
            </p>
            <h4 class="text-h4">Central de Vídeos</h4>
            <p class="text-p">
              Disponibilizamos aos nossos clientes manuais e tutoriais em
              formato de vídeos separados por tema, assistam e conheçam todas as
              funcionalidades do REP671.
              <a
                target="_blank"
                href="https://www.cartaodepontomrm.com.br/"
                >Clique aqui</a
              >
            </p>
            <h4 class="text-h4">Relatórios do REP671</h4>
            <p class="text-p">
              Informamos ao nossos clientes, que estamos utilizando as
              tecnologias mais atuais do mercado. O REP671 utiliza a geração e
              disponibilização de <strong>relatórios em formato PDF</strong> que
              é enviado ao seu email logo após a geração do mesmo, desta forma,
              há um melhor conforto e mobilidade para sua leitura e arquivamento
              em seu computador, evitando assim que o usuário tenha que salvar
              ou exportar em PDF, ou seja, o próprio sistema já realiza este
              procedimento.
            </p>
            <p class="text-p">
              <strong>Relatório já disponível:</strong> Resumo Analítico de
              Ponto.
            </p>
            <h4 class="text-h4">Opções de Equipamentos</h4>
            <p class="text-p">
              O REP671 tem como sua novidade principal, o registro de ponto via
              Registro Facial através do Web Browser, isto é sem a necessidade
              de instalação de programas no computador do cliente, facilitando
              muito a manutenção ou troca de computador quando há alguma
              necessidade por parte do cliente.
            </p>
            <p class="text-p">
              Hoje é possível registrar ponto através do computador usando uma
              webcam usb ou webcam embutida, sem necessidade de instalação de
              nenhum programa.
            </p>
            <p class="text-p">
              É possível também realizar registro de ponto via celular, apenas
              com um navegador disponível.
            </p>
            <p class="text-p">
              Estamos em fase de conclusão, o registro de ponto via biometria
              digital (dedo), semelhante ao REP373, sendo que já utilizando a
              nova arquitetura do sistema atual REP671.
            </p>
            <h4 class="text-h4">Registro INPI</h4>
            <p class="text-p">
              Informamos ao nossos clientes que nosso software é devidamente
              registrado junto ao INPI, conforme obrigatoriedade da Portaria
              671. Nosso número de Registro é: BR512022001370-3.
            </p>
          </div>
        </card>
      </div>
    </div>
    <PopupInformativo />
  </div>
</template>
<script>
import { Card, PopupInformativo } from "@/components/index";
import moment from "moment-timezone";
const https = require("https");
const httpsAgent = new https.Agent({
  rejectUnauthorized: false,
});

export default {
  components: {
    Card,
    PopupInformativo,
  },
  data() {
    return {
      relogios: [],
    };
  },
  computed: {},
  async mounted() {
    //await this.listarRelogios();
  },
  methods: {
    async loginLocal(e) {
      let th = this;
      let form = {
        ip: e.ip,
        porta: e.porta,
        login: e.usuario,
        password: e.senha,
      };

      th.axios
        .post(`https://${e.ip}/login.fcgi`, form, { httpsAgent: httpsAgent })
        .then(async (res) => {
          if (res.data.session) {
            await th.updateSessionLocal(e, res.data.session);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    async loginIdFace(e) {
      let th = this;
      let form = {
        login: e.usuario,
        password: e.senha,
      };

      await th.axios
        .post(`https://${e.ip}:${e.porta}/login.fcgi`, form, {
          httpsAgent: httpsAgent,
        })
        .then(async (res) => {
          if (res.data.session) {
            await th.updateSessionFaceId(e, res.data.session);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    async updateSessionLocal(relogio, session) {
      let th = this;
      relogio = {
        ...relogio,
        sessao: session,
      };
      let form = {
        setDB: th.$cookies.get("db"),
        relogio: relogio,
      };
      await th.axios
        .post("/api/relogio/updateSession", form)
        .then(async () => {
          await th.buscarArquivoCompleto(relogio);
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    async updateSessionFaceId(relogio, session) {
      let th = this;
      relogio = {
        ...relogio,
        sessao: session,
      };
      let form = {
        setDB: th.$cookies.get("db"),
        relogio: relogio,
      };
      await th.axios
        .post("/api/relogio/updateSession", form)
        .then(async () => {
          await th.buscarArquivoCompletoIdFace(relogio);
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    async sincronizaPontos() {
      let th = this;
      th.relogios.map(async (e) => {
        if (e.modelo == "IDFace/ IDFlex (Coletor REP-P)") {
          await th.loginIdFace(e);
        } else {
          await th.loginLocal(e);
        }
      });
    },

    async buscarArquivoCompletoIdFace(relogio) {
      let th = this;
      let form;
      let dataAtual = new Date();
      // Subtrai 5 dias da data atual
      dataAtual.setDate(dataAtual.getDate() - 5);
      /*       let dia = dataAtual.getDate();
      let mes = dataAtual.getMonth() + 1;
      let ano = dataAtual.getFullYear(); */

      if (relogio.tipoAfd == "671") {
        form = {
          mode: Number(`${relogio.tipoAfd}`),
          /*             "initial_date": {
                            "day":  Number(`${dia}`),
                            "month":  Number(`${mes}`),
                            "year":  Number(`${ano}`)
                        } */
        };
      } else {
        form = {
          /*             "initial_date": {
                            "day":  Number(`${dia}`),
                            "month":  Number(`${mes}`),
                            "year":  Number(`${ano}`)
            } */
        };
      }
      await th.axios
        .post(
          `https://${relogio.ip}:${relogio.porta}/export_afd.fcgi?session=${relogio.sessao}`,
          form,
          { httpsAgent: httpsAgent },
        )
        .then(async (res) => {
          let file = res.data;
          if (file) {
            await th.sincronizarArquivo(relogio, file);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    async buscarFusoPorPosto(dadosRelogio, db) {
      let timezone = "";
      try {
        const bodyFormData = {
          setDB: db,
          idPosto: dadosRelogio.id_empregador,
        };
        const response = await this.axios.post(
          "/api/empregador/buscarFusoPorPosto",
          bodyFormData,
        );
        const { fuso } = response.data.data.dados[0];
        timezone = fuso;
      } catch (err) {
        console.error(err);
      }
      await this.getCurrentDateTime(timezone, dadosRelogio);
    },

    async getCurrentDateTime(timezone, dadosRelogio) {
      try {
        const now = moment.tz(timezone);

        const currentDateTime = {
          day: now.format("DD"),
          hour: now.format("HH"),
          minute: now.format("mm"),
          month: now.format("MM"),
          second: now.format("ss"),
          year: now.format("YYYY"),
        };
        await this.atualizarDataHoraIdFace(dadosRelogio, currentDateTime);
      } catch (err) {
        return err;
      }
    },

    async atualizarDataHoraIdFace(dadosRelogio, currentDateTime) {
      try {
        const form = {
          day: Number(currentDateTime.day),
          hour: Number(currentDateTime.hour),
          minute: Number(currentDateTime.minute),
          month: Number(currentDateTime.month),
          second: Number(currentDateTime.second),
          year: Number(currentDateTime.year),
        };
        return await this.axios.post(
          `https://${dadosRelogio.ip}:${dadosRelogio.porta}/set_system_time.fcgi?session=${dadosRelogio.sessao}`,
          form,
          { httpsAgent: httpsAgent },
        );
      } catch (e) {
        throw {
          msg: "Falha ao tentar atualizar data e hora do idFace",
          error: e.toString(),
        };
      }
    },

    async buscarArquivoCompleto(relogio) {
      let th = this;
      let form;
      let dataAtual = new Date();
      // Subtrai 5 dias da data atual
      dataAtual.setDate(dataAtual.getDate() - 5);
      let dia = dataAtual.getDate();
      let mes = dataAtual.getMonth() + 1;
      let ano = dataAtual.getFullYear();

      if (relogio.tipoAfd == "671") {
        form = {
          mode: Number(`${relogio.tipoAfd}`),
          session: relogio.sessao,
          initial_date: {
            day: Number(`${dia}`),
            month: Number(`${mes}`),
            year: Number(`${ano}`),
          },
        };
      } else {
        form = {
          session: relogio.sessao,
          initial_date: {
            day: Number(`${dia}`),
            month: Number(`${mes}`),
            year: Number(`${ano}`),
          },
        };
      }
      await th.axios
        .post(`https://${relogio.ip}/get_afd.fcgi`, form, {
          httpsAgent: httpsAgent,
        })
        .then(async (res) => {
          let file = res.data;
          if (file) {
            await th.sincronizarArquivo(relogio, file);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    async sincronizarArquivo(re, file) {
      let th = this;
      let form = {
        setDB: th.$cookies.get("db"),
        id_empregador: re.id_empregador,
        file: file,
        modelo: re.modelo,
      };
      await th.axios
        .post("/api/sincronizando/pontosCompleto", form)
        .then((res) => {
          console.log("res", res);
          if (re.modelo == "IDFace/ IDFlex (Coletor REP-P)") {
            th.buscarFusoPorPosto(re, th.$cookies.get("db"));
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    async listarRelogios() {
      let th = this;
      let bodyFormData = {
        setDB: th.$cookies.get("db"),
      };
      await th.axios
        .post("/api/relogio/listarRelogios", bodyFormData)
        .then(async (response) => {
          th.relogios = response.data.data.dados;
          await th.sincronizaPontos();
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
  },
  beforeDestroy() {},
};
</script>
<style>
#worldMap .datamap {
  left: 0 !important;
}

.text-h4 {
  padding: 0px 10px 0px 10px;
  margin: 10px 0px 0px 0px;
}

.text-p {
  text-align: left;
  padding: 0px 20px 0px 20px;
}
</style>
